import React from "react";
import { observer } from "mobx-react";
import { Alert, Button } from "@mui/material";
import { useRootStore } from "../../../store/contexts";

type OutdatedAfterSaveNoticeProps = {
  /** Abierto cuando el guardado quedó hecho pero el formulario no se pudo poner al día (savedButOutdated del store). */
  open: boolean;
  /** Vuelve a leer el registro. */
  onReload: () => void;
  /** Recargar deshabilitado (mientras se relee). */
  reloadDisabled?: boolean;
};

/**
 * El aviso de un formulario guardado pero desactualizado: después de guardar no
 * se pudieron cargar los datos actualizados (la relectura falló, o el formulario
 * cambió mientras se guardaba). Guardar queda deshabilitado hasta recargar, así
 * nunca se guarda desde un estado viejo: ni filas con id del formulario, ni
 * archivos ya subidos, ni borrados ya aplicados.
 */
export const OutdatedAfterSaveNotice: React.FC<OutdatedAfterSaveNoticeProps> = observer(
  ({ open, onReload, reloadDisabled = false }) => {
    const { langStore } = useRootStore();
    if (!open) return null;
    return (
      <Alert
        severity="warning"
        sx={{ mb: 2 }}
        action={
          <Button color="inherit" size="small" onClick={onReload} disabled={reloadDisabled}>
            {langStore.reloadRecord}
          </Button>
        }
      >
        {langStore.savedButOutdated}
      </Alert>
    );
  }
);
